import { render, staticRenderFns } from "./tcMedicine2.0.vue?vue&type=template&id=71e38ff8&scoped=true&"
import script from "./tcMedicine2.0.vue?vue&type=script&lang=js&"
export * from "./tcMedicine2.0.vue?vue&type=script&lang=js&"
import style0 from "./tcMedicine2.0.vue?vue&type=style&index=0&id=71e38ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e38ff8",
  null
  
)

export default component.exports